import {
  Card,
  CardBody,
  Row,
  Col,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Breadcrumb,
  BreadcrumbItem,
} from "reactstrap";
import ReactTable from "components/ReactTable/ReactTable.js";
import Moment from "moment";
import "moment-timezone";
import React, { useMemo, useEffect, useContext } from "react";
import { NavLink, useLocation, useHistory } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MainContext } from "context/MainContext.js";

import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Utilities from "components/Utils/utilities";

function ConfigurationList() {
  const history = useHistory();
  const location = useLocation();
  const privileges = useContext(MainContext);

  useEffect(() => {
    if (!Utilities.hasAccess(privileges["devices.configurations.display"])) {
      history.push({
        pathname: "/",
      });
    } else if (Utilities.hasAgreedTerms() == "false") {
      history.push({
        pathname: "/auth/terms",
      });
    }
  }, []);

  const downloadConfigFile = (props) => {
    fetch("/api/v1/device/configuration/content", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
        id: props.row.original.id,
        mode: "manual",
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        // Start the file download
        const element = document.createElement("a");
        const file = new Blob([actualData.data.content], {
          type: "text/plain",
        });
        element.href = URL.createObjectURL(file);
        element.download = actualData.data.filename;
        document.body.appendChild(element); // Required for this to work in FireFox
        element.click();

        // Send a notification to confirm
        toast.info("Downloading the configuration file", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          theme: "colored",
        });
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const redirectToContent = (id, serialNumber) => {
    const location = {
      pathname: "/admin/configurations/content",
      state: {
        id: id,
        serialNumber: serialNumber,
      },
    };
    history.push(location);
  };

  const columns = useMemo(
    () => [
      {
        Header: "Backup Date",
        accessor: "creationDate",
        Cell: (props) => {
          return (
            <span>
              {props.settings.general_convert_date_with_user_timezone === "true"
                ? Moment(props.value)
                    .tz(props.settings.user_timezone)
                    .format("yy-MM-DD hh:mm:ss a")
                : Moment.utc(props.value).format("yy-MM-DD hh:mm:ss a")}
            </span>
          );
        },
        flex: "1 1 0",
      },
      {
        Header: "Id",
        accessor: "id",
        flex: "1 1 0",
        show: false,
        filterable: false,
        disableExport: true,
      },
      {
        Header: "",
        accessor: "actions",
        Cell: (props) => {
          return (
            <>
              {Utilities.hasAccess(
                privileges["devices.configurations.content.display"]
              ) ||
              Utilities.hasAccess(
                privileges["devices.configurations.content.download"]
              ) ? (
                <UncontrolledDropdown direction="down">
                  <DropdownToggle
                    caret
                    color="info"
                    style={{
                      padding: "6px 14px 6px 14px",
                      margin: "0px",
                    }}
                  >
                    Actions
                  </DropdownToggle>
                  <DropdownMenu container={"body"}>
                    {Utilities.hasAccess(
                      privileges["devices.configurations.content.display"]
                    ) ? (
                      <DropdownItem
                        onClick={() =>
                          redirectToContent(
                            props.row.original.id,
                            location.state.serialNumber
                          )
                        }
                      >
                        Show Content
                      </DropdownItem>
                    ) : (
                      ""
                    )}

                    {Utilities.hasAccess(
                      privileges["devices.configurations.content.download"]
                    ) ? (
                      <DropdownItem onClick={() => downloadConfigFile(props)}>
                        Download Content
                      </DropdownItem>
                    ) : (
                      ""
                    )}
                  </DropdownMenu>
                </UncontrolledDropdown>
              ) : (
                ""
              )}
            </>
          );
        },
        flex: "1 1 0",
        padding: "0px",
        sortable: false,
        filterable: false,
      },
    ],
    []
  );

  return (
    <>
      <ToastContainer />
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <Breadcrumb>
                  <BreadcrumbItem>
                    <NavLink
                      to={{
                        pathname: "/admin/dashboard",
                      }}
                    >
                      <FontAwesomeIcon icon={faHome} />
                    </NavLink>
                  </BreadcrumbItem>
                  <BreadcrumbItem>
                    <NavLink
                      to={{
                        pathname: "/admin/devices/list",
                      }}
                    >
                      GAM
                    </NavLink>
                    <i>&lt;{location.state.serialNumber}&gt;</i>
                  </BreadcrumbItem>
                  <BreadcrumbItem>Configurations</BreadcrumbItem>
                </Breadcrumb>
              </CardBody>
            </Card>
            <Card>
              <CardBody>
                <ReactTable
                  query="/api/v1/device/configuration/list"
                  columns={columns}
                  title="Device Configurations"
                  param={location.state.serialNumber}
                  className="-striped -highlight primary-pagination"
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default ConfigurationList;
